export const Card = ({ children, className = "", onClick, interactive = false, elevated = false, shine = false, ...props }) => (
  <div
    onClick={onClick}
    className={`
      bg-white rounded-[20px]
      border border-[#E8E6E1]
      ${elevated 
        ? 'shadow-[0_8px_32px_rgba(26,29,26,0.08),0_4px_12px_rgba(26,29,26,0.04)]' 
        : 'shadow-[0_2px_12px_rgba(26,29,26,0.05),0_1px_3px_rgba(26,29,26,0.03)]'
      }
      ${interactive 
        ? `cursor-pointer 
           hover:shadow-[0_16px_48px_rgba(26,29,26,0.10),0_6px_16px_rgba(26,29,26,0.05)] 
           hover:-translate-y-1.5
           hover:border-[#DAD8D2]
           active:translate-y-0 
           active:scale-[0.995]
           transition-all duration-[350ms] ease-[cubic-bezier(0.34,1.56,0.64,1)]` 
        : 'transition-all duration-300'
      }
      ${shine ? 'card-shine' : ''}
      ${className}
    `}
    {...props}
  >
    {children}
  </div>
);
